module.exports = __webpack_public_path__ + "static/img/2.d418193.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/hnweR22/2.jpg
// module id = lXtA
// module chunks = 1